module.exports = __webpack_public_path__ + "img/Geo-Talent logo.c0475f2a.png";